import { useEffect, useRef } from 'react';
import yoda from '@kibt/bridge';
import { useDetailPageStore } from '@/page/detail/store';

import { $k18n } from '@/common/i18n';
import { useSetState } from 'ahooks';

const skuSpecTypes = () => [
    { label: $k18n({ id: 'k_226117', text: '规格' }), value: 1 },
    { label: $k18n('颜色'), value: 2 },
    { label: $k18n('图案'), value: 3 },
    { label: $k18n('材质'), value: 5 },
    { label: $k18n('口味'), value: 6 },
    { label: $k18n('色号'), value: 7 },
    { label: $k18n('容量'), value: 8 },
    { label: $k18n('度数'), value: 9 },
    { label: $k18n('功效'), value: 10 },
    { label: $k18n('型号'), value: 11 },
    { label: $k18n('内存'), value: 12 },
    { label: $k18n('尺寸'), value: 13 },
    { label: $k18n('重量'), value: 14 },
    { label: $k18n('厚度'), value: 15 },
    { label: $k18n('适用肤质'), value: 16 },
    { label: $k18n('使用人群'), value: 17 },
    { label: $k18n('适用性别'), value: 18 },
    { label: $k18n('适用年纪'), value: 19 },
    { label: $k18n('适用季节'), value: 20 },
    { label: $k18n('货号'), value: 21 },
    { label: $k18n('尺'), value: 22 },
    { label: $k18n('款式'), value: 23 },
];

export function useShowSingleSpecStepper(pageData) {
    // 拉取ab实验，决定单规格数量累加器的展示位置

    // 是否是单规格以及单规格的规格名称和规格值
    // const [isSingleSpec, setIsSingleSpec] = useState(false);
    // const [singleSpecDesc, setSingleSpecDesc] = useState('');
    const [state, setState] = useSetState({
        isSingleSpec: false,
        singleSpecDesc: '',
    });

    useEffect(() => {
        // 转成map格式方便查找
        const skuSpecTypesMap = skuSpecTypes()?.reduce((acc, cur) => {
            acc[cur.value] = cur.label;
            return acc;
        }, {});

        const getSpecDesc = skuSpecs => {
            return skuSpecs?.reduce((acc, cur) => {
                return `${acc}${skuSpecTypesMap[cur.specId] || cur?.specName}:${cur?.specValueName}`; // 后端specName可能存在中文，先用specId来进行前端映射
            }, '');
        };

        if (pageData?.skus?.length === 1) {
            const specDesc = getSpecDesc(pageData?.skus?.[0]?.skuSpecs);
            setState({
                isSingleSpec: true,
                singleSpecDesc: specDesc,
            });
        }
    }, [pageData]);

    return {
        isSingleSpec: state.isSingleSpec,
        singleSpecDesc: state.singleSpecDesc,
    };
}

export function useSetDetailBuyNum(rawData) {
    const rawDataRef = useRef(null);
    const setStoreState = useDetailPageStore().setState;

    useEffect(() => {
        if (rawData?.minPurchase) {
            rawDataRef.current = rawData;
            setStoreState({ purchaseQuantity: rawData?.minPurchase || 1 });
        }
    }, [rawData]);

    if (yoda?.event) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        yoda.event.addEventListener('ecommerce://onSetDetailBuyNum', () => {
            setStoreState({ purchaseQuantity: rawDataRef.current?.minNum ?? 1 });
        });
    }
}
